import type { ReactNode } from "react";
import { cx } from "./cx";

export interface ChatBubbleProps {
  role: "user" | "assistant";
  children: ReactNode;
  /** Mono metadata line (timestamp, applied-change note). */
  meta?: ReactNode;
  className?: string;
}

/**
 * Chat/message bubble — the NL Q&A layer (M5) composes from this.
 * User turns are deep teal-ink bubbles; assistant turns are white bubbles on
 * a mint hairline. Each side softens one corner toward its speaker.
 */
export function ChatBubble({ role, children, meta, className }: ChatBubbleProps) {
  return (
    <div className={cx("pz-chat-row", role === "user" && "pz-chat-row--user")}>
      <div className={cx("pz-chat-bubble", `pz-chat-bubble--${role}`, className)}>
        {children}
        {meta != null && <span className="pz-chat-bubble__meta">{meta}</span>}
      </div>
    </div>
  );
}
